(function() {
  let cancelCurrent = null;
  // ─── Cached DOM refs ────────────────────────────────────────────────────────
  let _priceWrapper = null;
  let _priceSaleEl  = null;
  let _priceRegEl   = null;
  function getPriceEls() {
    const root = document.querySelector('product-info[data-section-type="product-page"]') || document;
    _priceWrapper = root.querySelector('.m-price, .price');
    _priceSaleEl = _priceWrapper?.querySelector('.m-price-item--sale, .price-item--sale');
    _priceRegEl = _priceWrapper?.querySelector('.m-price-item--regular, .price-item--regular');
  }
  // Product data is cached per handle so Combined Listings can switch products safely.
  let _productCache = null;
  function getProductHandle() {
    return (window.location.pathname.match(/\/products\/([^/?#]+)/) || [])[1]
      || document.querySelector('[data-product-handle]')?.dataset?.productHandle;
  }
  function getSelectedVariantId() {
    return document.querySelector('product-form.m-product-form--main input[name="id"]')?.value
      || new URLSearchParams(window.location.search).get('variant');
  }
  function formatPrice(cents) {
    return '$' + (cents / 100).toFixed(2);
  }
  function getVariantQuantity(variant) {
    const option = variant.options?.[0] || variant.title;
    if (/single/i.test(option)) return 1;
    const match = option.match(/^(\d+)/);
    return match ? parseInt(match[1], 10) : 1;
  }
  function updateBestvalue(priceCents, variant) {
    const qty = getVariantQuantity(variant);
    const el = _priceWrapper?.querySelector('.bestvalue');
    if (!el) return;
    if (qty <= 1) {
      el.style.display = 'none';
    } else {
      el.textContent = formatPrice(priceCents / qty) + '/ea.';
      el.style.display = '';
    }
  }
  function updateSubscriptionBadge(priceCents, compareCents) {
    getPriceEls();
    if (!_priceWrapper) return;
    const discountPct = compareCents > priceCents
      ? Math.round((1 - priceCents / compareCents) * 100)
      : 0;
    let badge = _priceWrapper.querySelector('[data-rc-save-badge]');
    if (!discountPct) {
      badge?.remove();
      return;
    }
    if (!badge) {
      badge = document.createElement('span');
      badge.setAttribute('data-rc-save-badge', '1');
      badge.style.cssText = [
        'display:inline-flex',
        'align-items:center',
        'gap:5px',
        'background:#2f27ce',
        'color:#fff',
        'font-size:12px',
        'font-weight:530',
        'letter-spacing:-0.3px',
        'padding:2px 6px',
        'border-radius:4px',
        'vertical-align:middle',
        'margin-left:10px',
        'white-space:nowrap'
      ].join(';');
      badge.innerHTML = '<svg id="a" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" width="8" height="10" viewBox="0 0 78.43 100" style="flex-shrink:0"><path d="M15.16,98.37c-7.17-2.81-12.41-8.88-14.38-16.66-1.94-7.68-.2-15.73,4.67-21.58L44.86,20.44H7.89V0h70.55v70.67s-19.66,0-20.4,0c0-2.72,0-5.44,0-8.16,0-5.11,0-10.22,0-15.33v-11.14s-35.84,36.08-35.84,36.08c-2.66,2.68-.76,7.24,3.01,7.24h23.63c0,3.59,0,17.52,0,20.64h-23.12c-3.41,0-6.8-.5-10.06-1.48l-.49-.15Z" fill="currentColor"/></svg><span data-rc-badge-label></span>';
      const bestvalue = _priceWrapper.querySelector('.bestvalue');
      bestvalue
        ? _priceWrapper.insertBefore(badge, bestvalue)
        : _priceWrapper.appendChild(badge);
    }
    setText(badge.querySelector('[data-rc-badge-label]'), 'Save ' + discountPct + '%');
  }
  function removeSubscriptionBadge() {
    _priceWrapper?.querySelector('[data-rc-save-badge]')?.remove();
  }
  function updateThemePriceBlock(saleCents, compareCents, variant) {
    getPriceEls();
    if (!_priceWrapper) return;
    _priceWrapper.classList.add('m-price--on-sale', 'price--on-sale');
    setText(_priceSaleEl, formatPrice(saleCents));
    setText(_priceRegEl, formatPrice(compareCents));
    if (variant) updateBestvalue(saleCents, variant);
    updateSubscriptionBadge(saleCents, compareCents);
  }
  function restoreThemePriceBlock() {
    getPriceEls();
    if (!_priceWrapper || !_productCache) return;
    const variant = _productCache.variants.find(
      v => String(v.id) === String(getSelectedVariantId())
    );
    if (!variant) return;
    const salePrice    = variant.price;
    const comparePrice = variant.compare_at_price && variant.compare_at_price > variant.price
      ? variant.compare_at_price
      : variant.price;
    _priceWrapper.classList.add('m-price--on-sale', 'price--on-sale');
    setText(_priceSaleEl, formatPrice(salePrice));
    setText(_priceRegEl, formatPrice(comparePrice));
    removeSubscriptionBadge();
    const bestvalueEl = _priceWrapper?.querySelector('.bestvalue');
    if (bestvalueEl) {
      const qty = getVariantQuantity(variant);
      if (qty <= 1) {
        bestvalueEl.style.display = 'none';
      } else {
        bestvalueEl.textContent = formatPrice(variant.price / qty) + '/ea.';
        bestvalueEl.style.display = '';
      }
    }
  }
  // Watch for Minimog replacing the .m-price wrapper on variant switch
  function watchPriceOverwrite(shadow) {
    const priceEl = document.querySelector('.m-price, .price');
    if (!priceEl) return;
    const parent = priceEl.parentElement;
    if (!parent || parent._rcObserved) return;
    parent._rcObserved = true;
    new MutationObserver(() => {
      _priceWrapper = null;
      _priceSaleEl  = null;
      _priceRegEl   = null;
      syncSubscriptionPrice(shadow);
    }).observe(parent, { childList: true });
  }
  async function fetchProductData(shadow) {
    const root = shadow ? mainRoot(shadow) : document.querySelector('product-info[data-section-type="product-page"]');
    const handle = root?.dataset?.productHandle || getProductHandle();
    if (!handle) return null;
    if (!productRequests.has(handle)) {
      productRequests.set(handle, fetch('/products/' + encodeURIComponent(handle) + '.js')
        .then(response => { if (!response.ok) throw new Error('Product lookup failed'); return response.json(); })
        .catch(() => { productRequests.delete(handle); return null; }));
    }
    const product = await productRequests.get(handle);
    if (product) _productCache = product;
    return product;
  }
  async function syncSubscriptionPrice(shadow, explicitVariantId) {
    const revision = ++syncRevision;
    setupDisplayObservers(shadow);
    shipmentStyles(shadow);
    const product = await fetchProductData(shadow);
    if (revision !== syncRevision || !product || !widgetHost(shadow)?.isConnected) return;
    refreshPriceRefs(shadow);
    const root = mainRoot(shadow);
    const variantId = explicitVariantId
      || root.querySelector('product-form.m-product-form--main input[name="id"]')?.value
      || getSelectedVariantId();
    if (syncQuantityPresentation(shadow, product, variantId)) {
      setupDisplayObservers(shadow);
      drainDisplayObservers(shadow);
      return;
    }
    const model = shipmentModel(product, variantId, selectedPlanId(shadow));
    const selected = !!shadow.querySelector('.rc-purchase-option__subscription[rc-selected]');
    if (model) {
      syncWidgetPrice(shadow, model);
      syncWidgetDiscount(shadow, model);
      syncBenefits(shadow, model);
      setPlanQuantity(shadow, selected ? model : null);
      if (selected) {
        updateThemePriceBlock(model.sale, model.regular, model.variant);
        _priceWrapper?.classList.toggle('m-price--on-sale', model.sale < model.regular);
        _priceWrapper?.classList.toggle('price--on-sale', model.sale < model.regular);
      } else restoreThemePriceBlock();
    } else {
      setPlanQuantity(shadow, null);
      shadow.querySelectorAll('[data-pl-total-price]').forEach(el => el.remove());
      shadow.querySelectorAll('[data-pl-shipment-price]').forEach(el => el.removeAttribute('data-pl-shipment-price'));
      shadow.querySelectorAll('[data-pl-benefits-fallback]').forEach(el => el.remove());
      restoreThemePriceBlock();
    }
    setupDisplayObservers(shadow);
    drainDisplayObservers(shadow);
  }
  // Animation behavior retained from the existing customization.
  function animateEase({ from, to, onUpdate }) {
    let current = from;
    let maxFrames = 60;
    let frameId;
    function frame() {
      if (--maxFrames <= 0) { onUpdate(to); return; }
      current += (to - current) * 0.2;
      if (Math.abs(to - current) < 0.1) { onUpdate(to); return; }
      onUpdate(current);
      frameId = requestAnimationFrame(frame);
    }
    frameId = requestAnimationFrame(frame);
    return () => cancelAnimationFrame(frameId);
  }
  function setupAnimation(shadow) {
    const subscriptionOption = shadow.querySelector('.rc-purchase-option__subscription');
    if (!subscriptionOption || subscriptionOption._rcAnimationSetup) return;
    subscriptionOption._rcAnimationSetup = true;
    const observer = new MutationObserver((mutations) => {
      for (const m of mutations) {
        if (m.type !== 'childList') continue;
        for (const node of m.removedNodes) {
          if (!node.classList?.contains('rc-purchase-option__sub-container') || node.dataset.rcClone) continue;
          const h = node.offsetHeight || 201;
          const clone = node.cloneNode(true);
          clone.dataset.rcClone = '1';
          clone.style.cssText += 'overflow:hidden;height:' + h + 'px;opacity:1;pointer-events:none;';
          observer.disconnect();
          subscriptionOption.appendChild(clone);
          observer.observe(subscriptionOption, { childList: true });
          if (cancelCurrent) cancelCurrent();
          cancelCurrent = animateEase({
            from: h, to: 0,
            onUpdate: v => {
              clone.style.height = v + 'px';
              clone.style.opacity = String(Math.max(v / h, 0));
              if (v <= 0.1) {
                observer.disconnect();
                clone.remove();
                observer.observe(subscriptionOption, { childList: true });
              }
            }
          });
        }
        for (const node of m.addedNodes) {
          if (!node.classList?.contains('rc-purchase-option__sub-container') || node.dataset.rcClone) continue;
          observer.disconnect();
          subscriptionOption.querySelectorAll('[data-rc-clone]').forEach(el => el.remove());
          observer.observe(subscriptionOption, { childList: true });
          injectBenefitsStyle(node.querySelector('rc-benefits'));
          injectPlansStyle(node.querySelector('rc-selling-plans'));
          injectRadioStyles(shadow);
          const benefits = node.querySelector('rc-benefits');
          const sellingPlans = node.querySelector('rc-selling-plans');
          if (benefits && sellingPlans &&
              benefits.compareDocumentPosition(sellingPlans) & Node.DOCUMENT_POSITION_FOLLOWING) {
            node.insertBefore(sellingPlans, benefits);
          }
          const newRcSP = node.querySelector('rc-selling-plans');
          if (newRcSP?.shadowRoot) {
            new MutationObserver(() => syncSubscriptionPrice(shadow))
              .observe(newRcSP.shadowRoot, {
                subtree: true,
                attributes: true,
                attributeFilter: ['checked', 'data-checked']
              });
          }
          requestAnimationFrame(() => syncSubscriptionPrice(shadow));
          requestAnimationFrame(() => {
            const h = node.scrollHeight;
            node.style.overflow = 'hidden';
            node.style.height = '0px';
            node.style.opacity = '0';
            if (cancelCurrent) cancelCurrent();
            cancelCurrent = animateEase({
              from: 0, to: h,
              onUpdate: v => {
                node.style.height = v + 'px';
                node.style.opacity = String(Math.min(v / h, 1));
                if (v >= h - 0.5) {
                  node.style.removeProperty('height');
                  node.style.removeProperty('overflow');
                  node.style.removeProperty('opacity');
                }
              }
            });
          });
        }
      }
    });
    observer.observe(subscriptionOption, { childList: true });
  }
  // ─── Style Injectors ───────────────────────────────────────────────────────
  function injectBenefitsStyle(benefitsEl) {
    if (!benefitsEl?.shadowRoot) return;
    if (benefitsEl.shadowRoot.querySelector('[data-benefits-style]')) return;
    const style = document.createElement('style');
    style.setAttribute('data-benefits-style', '1');
    style.textContent = `
      ul {
        list-style: none !important;
        padding-left: 0 !important;
        margin: 10px 0 10px !important;
      }
      li {
        font-family: var(--font-lay-grotesk) !important;
        font-weight: 530 !important;
        font-size: 13px !important;
        line-height: 24px !important;
        letter-spacing: -0.3px !important;
        color: #2F27CE !important;
        padding-left: 0 !important;
        position: static !important;
        display: flex !important;
        align-items: center !important;
        gap: 10px !important;
      }
li[data-pl-monthly-equivalent]::before {
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath fill='%232f27ce' d='M12,17.54l5-2.78v-5.89l-5.01-2.83-4.99,2.83v5.81l5,2.86h0ZM8,9.95l3.5,2v4.15l-3.5-2v-4.15ZM12.5,16.12v-4.16l3.5-2v4.22l-3.5,1.94ZM15.43,9.13l-3.42,1.96-3.43-1.96,3.42-1.94,3.43,1.94ZM24,3v4.5c0,.83-.67,1.5-1.5,1.5h-4.5v-1h4.24C20.6,3.79,16.57,1,12,1c-.76,0-1.51.08-2.24.23l-.2-.98c.8-.17,1.62-.25,2.44-.25,4.84,0,9.11,2.85,11,7.21V3h1ZM14.24,22.77l.2.98c-.8.17-1.62.25-2.44.25-4.84,0-9.11-2.85-11-7.21v4.21H0v-4.49c0-.83.67-1.5,1.5-1.5h4.5s0,.99,0,.99H1.76c1.64,4.22,5.67,7,10.24,7,.76,0,1.51-.08,2.24-.23ZM2.13,7.18l-.91-.45c.48-.98,1.09-1.89,1.82-2.71l.76.67c-.66.74-1.22,1.58-1.66,2.48ZM1,12H0C0,10.9.15,9.82.44,8.77l.97.27c-.26.94-.41,1.93-.41,2.96h0ZM5.25,3.33l-.62-.8c.86-.67,1.81-1.23,2.82-1.64l.38.93c-.93.38-1.8.89-2.58,1.51ZM23,12h1c0,1.1-.15,2.18-.44,3.23l-.97-.27c.26-.94.42-1.93.42-2.96h0ZM18.76,20.67l.62.8c-.86.67-1.81,1.23-2.82,1.64l-.38-.93c.93-.38,1.8-.89,2.58-1.51ZM21.87,16.82l.91.44c-.48.98-1.09,1.89-1.82,2.71l-.75-.67c.66-.74,1.22-1.58,1.66-2.48Z'/%3E%3C/svg%3E") !important;
}
      li::before {
        content: '' !important;
        display: block !important;
        width: 14px !important;
        height: 14px !important;
        min-width: 14px !important;
        position: static !important;
        transform: none !important;
        top: unset !important;
        left: unset !important;
        flex-shrink: 0 !important;
        mask-image: none !important;
        -webkit-mask-image: none !important;
        background-color: transparent !important;
        background-size: contain !important;
        background-repeat: no-repeat !important;
        background-position: center !important;
      }
      li[hidden] { display:none !important; }
    li:nth-child(1)::before {
        background-image: url("data:image/svg+xml,%3Csvg id='a' xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'%3E%3Cpath fill='%232f27ce' d='M416%2C42.67h-32V10.67c0-5.89-4.78-10.67-10.67-10.67s-10.67%2C4.78-10.67%2C10.67v32h-213.33V10.67c0-5.89-4.78-10.67-10.67-10.67s-10.67%2C4.78-10.67%2C10.67v32h-32C43.07%2C42.67%2C0%2C85.74%2C0%2C138.67v277.33c0%2C52.93%2C43.07%2C96%2C96%2C96h85.33c5.89%2C0%2C10.67-4.78%2C10.67-10.67s-4.78-10.67-10.67-10.67h-85.33c-41.17%2C0-74.67-33.49-74.67-74.67v-224h480c5.89%2C0%2C10.67-4.78%2C10.67-10.67v-42.67c0-52.93-43.07-96-96-96ZM490.67%2C170.67H21.33v-32c0-41.17%2C33.49-74.67%2C74.67-74.67h320c41.17%2C0%2C74.67%2C33.49%2C74.67%2C74.67v32ZM420.95%2C250.28l-164.42%2C164.42c-14.1%2C14.1-21.87%2C32.85-21.87%2C52.8v33.83c0%2C5.89%2C4.78%2C10.67%2C10.67%2C10.67h33.83c19.95%2C0%2C38.7-7.77%2C52.8-21.87l164.42-164.42c10.07-10.07%2C15.62-23.47%2C15.62-37.72s-5.55-27.65-15.62-37.72c-20.12-20.14-55.3-20.14-75.41%2C0h-.02ZM481.28%2C310.61l-164.42%2C164.42c-10.07%2C10.07-23.47%2C15.62-37.72%2C15.62h-23.17v-23.17c0-14.25%2C5.55-27.63%2C15.62-37.72l164.42-164.42c12.07-12.07%2C33.17-12.07%2C45.25%2C0%2C6.04%2C6.04%2C9.37%2C14.08%2C9.37%2C22.63s-3.33%2C16.58-9.37%2C22.63h.02ZM106.65%2C287.98c0-5.89%2C4.78-10.67%2C10.67-10.67h192.02c5.89%2C0%2C10.67%2C4.78%2C10.67%2C10.67s-4.78-10.67-10.67-10.67H117.33c-5.89%2C0-10.67-4.78-10.67-10.67h-.02ZM213.31%2C394.65c0%2C5.89-4.78%2C10.67-10.67%2C10.67h-85.31c-5.89%2C0-10.67-4.78-10.67-10.67s4.78-10.67%2C10.67-10.67h85.33c5.89%2C0%2C10.67%2C4.78%2C10.67%2C10.67h-.02Z'/%3E%3C/svg%3E") !important;
      }
      li:nth-child(2)::before {
        background-image: url("data:image/svg+xml,%3Csvg id='a' xmlns='http://www.w3.org/2000/svg' width='23.98' height='24' viewBox='0 0 23.98 24'%3E%3Cpath fill='%232f27ce' d='M1%2C11.52c-.01.27-.23.48-.5.48h-.02c-.28-.01-.49-.24-.48-.52C.28%2C5.04%2C5.54%2C0%2C11.99%2C0c4.04%2C0%2C7.79%2C2.07%2C10%2C5.41V.5c0-.28.22-.5.5-.5s.5.22.5.5v5c0%2C.83-.67%2C1.5-1.5%2C1.5h-5c-.28%2C0-.5-.22-.5-.5s.22-.5.5-.5h4.69c-2.02-3.09-5.47-5-9.19-5C6.08%2C1%2C1.25%2C5.62%2C1%2C11.52ZM23.5%2C12c-.32-.02-.51.2-.52.48-.25%2C5.9-5.08%2C10.52-10.99%2C10.52-3.72%2C0-7.17-1.91-9.19-5h4.69c.28%2C0%2C.5-.22.5-.5s-.22-.5-.5-.5H2.49c-.83%2C0-1.5.67-1.5%2C1.5v5c0%2C.28.22.5.5.5s.5-.22.5-.5v-4.91c2.21%2C3.35%2C5.96%2C5.41%2C10%2C5.41%2C6.45%2C0%2C11.71-5.04%2C11.99-11.48.01-.28-.2-.51-.48-.52Z'/%3E%3C/svg%3E") !important;
      }
    `;
    benefitsEl.shadowRoot.appendChild(style);
  }
  function injectPlansStyle(sellingPlansEl) {
    if (!sellingPlansEl?.shadowRoot) return;
    if (sellingPlansEl.shadowRoot.querySelector('[data-plans-style]')) return;
    const style = document.createElement('style');
    style.setAttribute('data-plans-style', '1');
    style.textContent = `
      .rc-plans__label {
        font-family: var(--font-mono) !important;
        font-size: 12px !important;
        font-weight: 450 !important;
        letter-spacing: -0.3px !important;
        margin-bottom: 0 !important;
      }
      .rc-plans-button__interval {
        flex-direction: row !important;
        font-family: var(--font-lay-grotesk) !important;
        font-size: 13px !important;
        font-weight: 530 !important;
        gap: 8px;
        letter-spacing: -0.2px !important;
      }
      .rc-plans-button__discount {
        font-family: var(--font-lay-grotesk) !important;
        font-size: 12px !important;
        letter-spacing: -0.2px !important;
      }
  fieldset.rc-plans-button-group {
  display: flex !important;
  flex-wrap: wrap !important;
  gap: 8px !important;
  width: 100% !important;
  padding: 0 !important;
  border: 0 !important;
  margin: 0 !important;
  box-sizing: border-box !important;
}
label[part="rc-plans-radio-button"] {
  flex-grow: 1 !important;
  flex-shrink: 1 !important;
  flex-basis: 0 !important;
  min-width: 0 !important;
  width: 0 !important;
  box-sizing: border-box !important;
}
/* 5 plans: 3 on top, 2 stretched on bottom */
fieldset.rc-plans-button-group:has(> label:nth-child(5):last-child) > label {
  width: auto !important;
}
      @media (max-width: 749px) {
       .rc-purchase-option__selector {
        font-family: var(--font-lay-grotesk) !important;
        font-size: 16px !important;
        font-weight: 600 !important;
        letter-spacing: -0.2px !important;
        color: #111;
      }
        fieldset.rc-plans-button-group {
          grid-template-columns: repeat(2, 1fr) !important;
        }
      }
      label[part="rc-plans-radio-button"] {
        width: 100% !important;
        min-width: 0 !important;
      }
      .rc-plans-button {
        width: 100% !important;
        min-width: 0 !important;
        box-sizing: border-box !important;
        text-align: center !important;
        transition: all 0.2s ease !important;
        background: #f5f5f5 !important;
        border-radius: 8px !important;
        border: 1px solid #f5f5f5 !important;
      }
      .rc-plans-button:hover {
        background: #f5f5f5 !important;
        color: #222 !important;
        border: 1px solid #222 !important;
      }
      .rc-plans-button[data-checked] {
        background: #222222 !important;
        color: #fff !important;
        border: 1px solid #222 !important;
      }
    `;
    sellingPlansEl.shadowRoot.appendChild(style);
  }
  function injectRadioStyles(shadow) {
    shadow.querySelectorAll('rc-radio-icon').forEach(icon => {
      if (!icon.shadowRoot || icon.shadowRoot.querySelector('[data-radio-style]')) return;
      const style = document.createElement('style');
      style.setAttribute('data-radio-style', '1');
      style.textContent = `
        circle { fill: #2F27CE !important; transform-origin: center; transform: scale(1.25); }
        rect:last-of-type { stroke: #2F27CE !important; }
      `;
      icon.shadowRoot.appendChild(style);
    });
  }
  // ─── Customize (runs once per render cycle) ────────────────────────────────
  function injectBaseStyle(shadow) {
    if (shadow.querySelector('style[data-rc-custom]')) return;
    const style = document.createElement('style');
    style.setAttribute('data-rc-custom', '1');
    style.textContent = `
    @media (max-width: 749px) {
       .rc-purchase-option__selector {
        font-family: var(--font-lay-grotesk) !important;
        font-size: 16px !important;
        font-weight: 600 !important;
        letter-spacing: -0.2px !important;
        color: #111;
      }
  }
    .rc-selection__onetime[rc-selected] .rc-purchase-option__selector {
     color: #111!important;
  }
      [part~="rc-purchase-option__onetime"] [part~="rc-purchase-option__selector_onetime"] {
        font-size: 14px !important;
        color: #6b7280;
        font-weight: 600 !important;
      }
      [part~="rc-purchase-option__onetime"] .rc-price {
        font-size: 14px !important;
        color: #222 !important;
        font-weight: 500 !important;
      }
         svg.rc-checked-icon {height:1em!important;}
      .rc-price { letter-spacing: -0.1px !important; }
      .text-muted { font-size: 12px !important; font-weight: 450 !important; }
      .rc-purchase-option:not(:last-child) { margin-bottom: 0 !important; }
      .rc-purchase-option__selector {
        font-family: var(--font-lay-grotesk) !important;
        font-size: 18px;
        font-weight: 600 !important;
        letter-spacing: -0.2px !important;
        color: #111;
      }
      .rc-purchase-option { border: 1px solid transparent !important; }
      .rc-purchase-option[rc-selected] {
        border-radius: 5px !important;
        color: #111;
        background: #fff !important;
      }
      .compact .rc-purchase-option__label { font-size:unset!important;line-height:1!important;border-radius: 12px !important; padding:16px!important;}
      .rc-purchase-option__sub-container {
        padding: 0 16px !important;
        background: #fff !important;
        border-radius: 20px !important;
        overflow: hidden !important;
        will-change: height, opacity !important;
      }
      svg.rc-checked-icon rect { fill: unset !important; }
      .rc-purchase-option__checked-indicator {
        margin-right: 5px;
        background: #fff !important;
        border-radius: 99999px !important;
      }
      .rc-price { font-size: 16px; font-weight: 700 !important; }
      .rc-price .strike-through { font-weight: 530 !important; }
      .rc-purchase-option__badge {
        display: flex;
        gap: 6px;
        align-items: center;
        position: absolute;
        width: fit-content !important;
        padding: 4px 8px !important;
        background: var(--rc-widget-badge-bg-color);
        color: var(--rc-widget-badge-text-color);
        font-size: 11px !important;
        font-family: var(--font-lay-grotesk) !important;
        font-weight: 530 !important;
        line-height: 1 !important;
        letter-spacing: 0 !important;
        text-transform: none !important;
        border-radius: 4px !important;
      }
      .rc-purchase-option__subscription { --rc-widget-brand-color: #111; }
    `;
    shadow.appendChild(style);
  }
  function syncBadgePercent(shadow) {
    // Resolved from the actual selected selling-plan allocation in syncSubscriptionPrice.
    // Never copy the literal {discount} placeholder into the purchase-option title.
  }
  function syncQuantityPresentation(shadow, product, variantId) {
    const native = shadow.querySelector('recharge-quantity-upsell');
    if (!native?.shadowRoot) return false;
    const inputs = [...native.shadowRoot.querySelectorAll('input[name="quantityUpsellOption"]')];
    const planInputs = inputs.filter(input => input.value);
    const oneTime = inputs.find(input => !input.value);
    const models = planInputs.map(input => shipmentModel(product, variantId, input.value));
    const variant = product.variants.find(item => String(item.id) === String(variantId));
    if (!variant || !models.length || models.some(model => !model || !model.managedQuantity)) {
      native.style.removeProperty('display');
      shadow.querySelector('[data-pl-quantity-view]')?.remove();
      return true;
    }
    let view = shadow.querySelector('[data-pl-quantity-view]');
    if (!view) {
      view = document.createElement('div');
      view.setAttribute('data-pl-quantity-view', '');
      view.className = 'pl-qu';
      view.innerHTML = `<style>
        .pl-qu {font-family:var(--font-lay-grotesk,inherit);font-size:14px;line-height:20px;color:#333;background:#f3f4f6;padding:0;border-radius:5px;box-sizing:border-box;}
        .pl-qu * {box-sizing:border-box;}
        .pl-qu [hidden] {display:none!important;}
        .pl-qu .pl-qu-card {position:relative;border:1px solid transparent;border-radius:5px;}
        .pl-qu .pl-qu-card.is-selected {background:#fff;}
        .pl-qu .pl-qu-heading {display:flex;align-items:center;gap:8px;min-height:58px;margin:0;padding:16px;cursor:pointer;}
        .pl-qu input[type=radio] {appearance:none;-webkit-appearance:none;display:block;flex:0 0 20.125px;width:20.125px;height:20.125px;margin:0;border:.83854px solid #2f27ce;border-radius:50%;background:transparent;cursor:pointer;}
        .pl-qu .pl-qu-heading > input[type=radio] {position:static!important;inset:auto!important;display:block!important;visibility:visible!important;opacity:1!important;width:20.125px!important;height:20.125px!important;min-width:20.125px!important;max-width:20.125px!important;min-height:20.125px!important;max-height:20.125px!important;flex:0 0 20.125px!important;margin:0!important;padding:0!important;clip:auto!important;clip-path:none!important;transform:none!important;overflow:visible!important;pointer-events:auto!important;appearance:none!important;-webkit-appearance:none!important;border:.83854px solid #2f27ce!important;border-radius:50%!important;background:transparent!important;}
        .pl-qu .pl-qu-heading > input[type=radio]:checked {background:radial-gradient(circle,#2f27ce 0 6.289px,transparent 6.789px)!important;}
        .pl-qu input[type=radio]:checked {background:radial-gradient(circle,#2f27ce 0 6.289px,transparent 6.789px);}
        .pl-qu input:focus-visible,.pl-qu button:focus-visible {outline:2px solid #2f27ce;outline-offset:3px;}
        .pl-qu .pl-qu-title {font-size:17.5px;font-weight:600;line-height:1.2;letter-spacing:-.2px;}
        .pl-qu .pl-qu-price {display:inline-flex;align-items:baseline;justify-content:flex-end;gap:6px;margin-left:auto;white-space:nowrap;font-size:16px;line-height:1.3;letter-spacing:-.1px;font-weight:700;color:#0f866a;}
        .pl-qu .pl-qu-price del {font-size:12px;font-weight:530;color:#666;}
        .pl-qu .pl-qu-badge {position:absolute;right:12px;top:-10px;display:flex;padding:4px 8px;border-radius:4px;background:#0f866a;color:#fff;font-size:11px;font-weight:530;line-height:1;letter-spacing:0;}
        .pl-qu .pl-qu-detail {padding:0 16px 6px;}
        .pl-qu fieldset {min-width:0;margin:0;padding:0;border:0;}
        .pl-qu legend {padding:0;margin:0;font-family:var(--font-mono,monospace);font-size:12px;font-weight:450;line-height:21px;letter-spacing:-.3px;}
        .pl-qu .pl-qu-plans {display:flex;flex-wrap:wrap;gap:8px;}
        .pl-qu .pl-qu-plan {flex:1 1 0;min-width:0;display:flex;align-items:center;justify-content:center;text-align:center;position:relative;cursor:pointer;}
        .pl-qu .pl-qu-plan input {position:absolute;opacity:0;width:1px;height:1px;}
        .pl-qu .pl-qu-plan span {display:block;width:100%;height:100%;padding:7px;white-space:normal;overflow-wrap:anywhere;border:1px solid #f5f5f5;border-radius:8px;background:#f5f5f5;color:#333;font-size:13px;font-weight:530;line-height:20px;letter-spacing:-.2px;}
        .pl-qu .pl-qu-plan input:checked + span {background:#222;color:#fff;border-color:#222;}
        .pl-qu .pl-qu-plan input:focus-visible + span {outline:2px solid #2f27ce;outline-offset:3px;}
        .pl-qu .pl-qu-plan:hover span {border-color:#222;}
        .pl-qu ul {list-style:none;margin:18px 0 10px;padding:0;}
        .pl-qu li {display:flex;align-items:center;gap:10px;margin:0;padding:0;color:#2f27ce;font-size:13px;font-weight:530;line-height:24px;letter-spacing:-.3px;}
        .pl-qu li::before {content:'';display:block;flex:0 0 14px;width:14px;height:14px;background-size:contain;background-repeat:no-repeat;background-position:center;}
        .pl-qu li:nth-child(1)::before {background-image:url("data:image/svg+xml,%3Csvg id='a' xmlns='http://www.w3.org/2000/svg' width='512' height='512' viewBox='0 0 512 512'%3E%3Cpath fill='%232f27ce' d='M416%2C42.67h-32V10.67c0-5.89-4.78-10.67-10.67-10.67s-10.67%2C4.78-10.67%2C10.67v32h-213.33V10.67c0-5.89-4.78-10.67-10.67-10.67s-10.67%2C4.78-10.67%2C10.67v32h-32C43.07%2C42.67%2C0%2C85.74%2C0%2C138.67v277.33c0%2C52.93%2C43.07%2C96%2C96%2C96h85.33c5.89%2C0%2C10.67-4.78%2C10.67-10.67s-4.78-10.67-10.67-10.67h-85.33c-41.17%2C0-74.67-33.49-74.67-74.67v-224h480c5.89%2C0%2C10.67-4.78%2C10.67-10.67v-42.67c0-52.93-43.07-96-96-96ZM490.67%2C170.67H21.33v-32c0-41.17%2C33.49-74.67%2C74.67-74.67h320c41.17%2C0%2C74.67%2C33.49%2C74.67%2C74.67v32ZM420.95%2C250.28l-164.42%2C164.42c-14.1%2C14.1-21.87%2C32.85-21.87%2C52.8v33.83c0%2C5.89%2C4.78%2C10.67%2C10.67%2C10.67h33.83c19.95%2C0%2C38.7-7.77%2C52.8-21.87l164.42-164.42c10.07-10.07%2C15.62-23.47%2C15.62-37.72s-5.55-27.65-15.62-37.72c-20.12-20.14-55.3-20.14-75.41%2C0h-.02ZM481.28%2C310.61l-164.42%2C164.42c-10.07%2C10.07-23.47%2C15.62-37.72%2C15.62h-23.17v-23.17c0-14.25%2C5.55-27.63%2C15.62-37.72l164.42-164.42c12.07-12.07%2C33.17-12.07%2C45.25%2C0%2C6.04%2C6.04%2C9.37%2C14.08%2C9.37%2C22.63s-3.33%2C16.58-9.37%2C22.63h.02ZM106.65%2C287.98c0-5.89%2C4.78-10.67%2C10.67-10.67h192.02c5.89%2C0%2C10.67%2C4.78%2C10.67%2C10.67s-4.78-10.67-10.67-10.67H117.33c-5.89%2C0-10.67-4.78-10.67-10.67h-.02ZM213.31%2C394.65c0%2C5.89-4.78%2C10.67-10.67%2C10.67h-85.31c-5.89%2C0-10.67-4.78-10.67-10.67s4.78-10.67%2C10.67-10.67h85.33c5.89%2C0%2C10.67%2C4.78%2C10.67%2C10.67h-.02Z'/%3E%3C/svg%3E");}
        .pl-qu li:nth-child(2)::before {background-image:url("data:image/svg+xml,%3Csvg id='a' xmlns='http://www.w3.org/2000/svg' width='23.98' height='24' viewBox='0 0 23.98 24'%3E%3Cpath fill='%232f27ce' d='M1%2C11.52c-.01.27-.23.48-.5.48h-.02c-.28-.01-.49-.24-.48-.52C.28%2C5.04%2C5.54%2C0%2C11.99%2C0c4.04%2C0%2C7.79%2C2.07%2C10%2C5.41V.5c0-.28.22-.5.5-.5s.5.22.5.5v5c0%2C.83-.67%2C1.5-1.5%2C1.5h-5c-.28%2C0-.5-.22-.5-.5s.22-.5.5-.5h4.69c-2.02-3.09-5.47-5-9.19-5C6.08%2C1%2C1.25%2C5.62%2C1%2C11.52ZM23.5%2C12c-.32-.02-.51.2-.52.48-.25%2C5.9-5.08%2C10.52-10.99%2C10.52-3.72%2C0-7.17-1.91-9.19-5h4.69c.28%2C0%2C.5-.22.5-.5s-.22-.5-.5-.5H2.49c-.83%2C0-1.5.67-1.5%2C1.5v5c0%2C.28.22.5.5.5s.5-.22.5-.5v-4.91c2.21%2C3.35%2C5.96%2C5.41%2C10%2C5.41%2C6.45%2C0%2C11.71-5.04%2C11.99-11.48.01-.28-.2-.51-.48-.52Z'/%3E%3C/svg%3E");}
        .pl-qu li[data-qu-equivalent]::before {background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath fill='%232f27ce' d='M12,17.54l5-2.78v-5.89l-5.01-2.83-4.99,2.83v5.81l5,2.86h0ZM8,9.95l3.5,2v4.15l-3.5-2v-4.15ZM12.5,16.12v-4.16l3.5-2v4.22l-3.5,1.94ZM15.43,9.13l-3.42,1.96-3.43-1.96,3.42-1.94,3.43,1.94ZM24,3v4.5c0,.83-.67,1.5-1.5,1.5h-4.5v-1h4.24C20.6,3.79,16.57,1,12,1c-.76,0-1.51.08-2.24.23l-.2-.98c.8-.17,1.62-.25,2.44-.25,4.84,0,9.11,2.85,11,7.21V3h1ZM14.24,22.77l.2.98c-.8.17-1.62.25-2.44.25-4.84,0-9.11-2.85-11-7.21v4.21H0v-4.49c0-.83.67-1.5,1.5-1.5h4.5s0,.99,0,.99H1.76c1.64,4.22,5.67,7,10.24,7,.76,0,1.51-.08,2.24-.23ZM2.13,7.18l-.91-.45c.48-.98,1.09-1.89,1.82-2.71l.76.67c-.66.74-1.22,1.58-1.66,2.48ZM1,12H0C0,10.9.15,9.82.44,8.77l.97.27c-.26.94-.41,1.93-.41,2.96h0ZM5.25,3.33l-.62-.8c.86-.67,1.81-1.23,2.82-1.64l.38.93c-.93.38-1.8.89-2.58,1.51ZM23,12h1c0,1.1-.15,2.18-.44,3.23l-.97-.27c.26-.94.42-1.93.42-2.96h0ZM18.76,20.67l.62.8c-.86.67-1.81,1.23-2.82,1.64l-.38-.93c.93-.38,1.8-.89,2.58-1.51ZM21.87,16.82l.91.44c-.48.98-1.09,1.89-1.82,2.71l-.75-.67c.66-.74,1.22-1.58,1.66-2.48Z'/%3E%3C/svg%3E") !important;}
        .pl-qu .pl-qu-onetime .pl-qu-title {font-size:14px;color:#6b7280;}
        .pl-qu .pl-qu-onetime.is-selected .pl-qu-title {color:#111;}
        .pl-qu .pl-qu-onetime .pl-qu-price {font-size:14px;font-weight:500;color:#222;}
        @media(max-width:749px){.pl-qu .pl-qu-title{font-size:16px;}.pl-qu .pl-qu-heading{gap:6px;}.pl-qu .pl-qu-price{gap:4px;font-size:15px;}}
      </style><div class="pl-qu-card" data-qu-sub><span class="pl-qu-badge" data-qu-badge></span><label class="pl-qu-heading"><input type="radio" name="pl-qu-mode" value="subscription"><span class="pl-qu-title" data-qu-title></span><span class="pl-qu-price"><del data-qu-regular></del><span data-qu-sale></span></span></label><div class="pl-qu-detail" data-qu-detail><fieldset><legend>Delivery every:</legend><div class="pl-qu-plans" data-qu-plans></div></fieldset><ul><li data-qu-saving></li><li>Modify or cancel anytime.</li><li data-qu-equivalent hidden></li></ul></div></div><div class="pl-qu-card pl-qu-onetime" data-qu-onetime><label class="pl-qu-heading"><input type="radio" name="pl-qu-mode" value="onetime"><span class="pl-qu-title">One-time Purchase</span><span class="pl-qu-price" data-qu-onetime-price></span></label></div>`;
      native.after(view);
      view.addEventListener('change', event => {
        event.stopPropagation();
        const control = event.target;
        if (!(control instanceof HTMLInputElement)) return;
        const state = view._plState;
        const id = control.name === 'pl-qu-plan' ? control.value
          : control.value === 'onetime' ? '' : view.dataset.lastPlan;
        const target = state.native.shadowRoot?.querySelectorAll('input[name="quantityUpsellOption"]');
        const input = [...(target || [])].find(item => item.value === id);
        if (input && !input.disabled) {
          input.click();
          requestAnimationFrame(() => syncSubscriptionPrice(shadow));
        }
      });
    }
    view._plState = { native };
    const selected = planInputs.find(input => input.checked || input.closest('[rc-selected]'));
    const remembered = models.find(model => String(model.plan.id) === view.dataset.lastPlan);
    const model = models.find(item => String(item.plan.id) === selected?.value) || remembered || models[0];
    view.dataset.lastPlan = String(model.plan.id);
    const signature = JSON.stringify(models.map(item => [item.plan.id, item.quantity, item.plan.name]));
    if (view.dataset.plans !== signature) {
      const list = view.querySelector('[data-qu-plans]');
      list.replaceChildren();
      models.forEach(item => {
        const label = document.createElement('label');
        label.className = 'pl-qu-plan';
        const radio = document.createElement('input');
        radio.type = 'radio'; radio.name = 'pl-qu-plan'; radio.value = String(item.plan.id);
        const text = document.createElement('span');
        text.textContent = item.plan.name;
        radio.setAttribute('aria-label', `${item.plan.name}. ${item.quantity} ${item.quantity === 1 ? 'unit' : 'units'} per shipment.`);
        label.append(radio, text); list.append(label);
      });
      view.dataset.plans = signature;
    }
    view.querySelectorAll('input[name="pl-qu-plan"]').forEach(input => {
      input.checked = input.value === String(model.plan.id);
      input.disabled = !!planInputs.find(item => item.value === input.value)?.disabled;
    });
    const subscribed = !!selected;
    view.querySelector('input[value="subscription"]').checked = subscribed;
    view.querySelector('input[value="onetime"]').checked = !subscribed;
    view.querySelector('[data-qu-sub]').classList.toggle('is-selected', subscribed);
    view.querySelector('[data-qu-onetime]').classList.toggle('is-selected', !subscribed);
    view.querySelector('[data-qu-detail]').hidden = !subscribed;
    view.querySelector('[data-qu-onetime]').hidden = !oneTime;
    setText(view.querySelector('[data-qu-title]'), model.discount ? `Autoship & Save ${model.discount}%` : 'Autoship');
    setText(view.querySelector('[data-qu-badge]'), `Save ${model.discount}%`);
    view.querySelector('[data-qu-badge]').hidden = !model.discount;
    setText(view.querySelector('[data-qu-regular]'), formatPrice(model.regular));
    view.querySelector('[data-qu-regular]').hidden = model.regular <= model.sale;
    setText(view.querySelector('[data-qu-sale]'), formatPrice(model.sale));
    setText(view.querySelector('[data-qu-onetime-price]'), formatPrice(variant.price));
    setText(view.querySelector('[data-qu-saving]'), `Save ${model.discount}% on all autoship orders.`);
    view.querySelector('[data-qu-saving]').hidden = !model.discount;
    const equivalent = view.querySelector('[data-qu-equivalent]');
    const showEquivalent = model.managedQuantity && model.quantity > 1 && model.intervalUnit === 'month' && model.interval > 1;
    equivalent.hidden = !showEquivalent;
    setText(equivalent, showEquivalent ? `${formatPrice(model.sale / model.interval)} per month equivalent — ${formatPrice(model.sale)} billed every ${model.interval} months.` : '');
    native.style.setProperty('display', 'none', 'important');
    currentDisplay = { shadow, model: null };
    refreshPriceRefs(shadow);
    if (subscribed) updateThemePriceBlock(model.sale, model.regular, model.variant);
    else restoreThemePriceBlock();
    return true;
  }
  function customize(shadow, host) {
    injectBaseStyle(shadow);
    injectRadioStyles(shadow);
    setupAnimation(shadow);
    syncBadgePercent(shadow);
    syncSubscriptionPrice(shadow);
    const sub = shadow.querySelector('.rc-purchase-option__sub-container');
    if (!sub) return !!shadow.querySelector('recharge-quantity-upsell');
    const benefits = sub.querySelector('rc-benefits');
    const sellingPlans = sub.querySelector('rc-selling-plans');
    if (benefits && sellingPlans &&
        benefits.compareDocumentPosition(sellingPlans) & Node.DOCUMENT_POSITION_FOLLOWING) {
      sub.insertBefore(sellingPlans, benefits);
    }
    if (benefits) injectBenefitsStyle(benefits);
    if (sellingPlans) injectPlansStyle(sellingPlans);
    return !!sellingPlans;
  }
  // ─── Price signal watchers ──────────────────────────────────────────────────
  function watchPriceSignals(shadow) {
    if (shadow._rcPriceWatcher) return;
    shadow._rcPriceWatcher = true;
    shadow.querySelectorAll('rc-purchase-option').forEach(opt => {
      new MutationObserver(() => syncSubscriptionPrice(shadow))
        .observe(opt, { attributes: true, attributeFilter: ['rc-selected'] });
    });
    function watchSellingPlansShadow() {
      const rcSP = shadow.querySelector('rc-selling-plans');
      if (!rcSP?.shadowRoot || rcSP._rcPlanWatcher) return;
      rcSP._rcPlanWatcher = true;
      new MutationObserver(() => syncSubscriptionPrice(shadow))
        .observe(rcSP.shadowRoot, {
          subtree: true,
          attributes: true,
          attributeFilter: ['checked', 'data-checked']
        });
    }
    watchSellingPlansShadow();
    new MutationObserver(watchSellingPlansShadow)
      .observe(shadow, { childList: true });
    shadow.addEventListener('change', () => syncSubscriptionPrice(shadow), true);
  }
  // ─── watchShadow ───────────────────────────────────────────────────────────
  function watchShadow(shadow, host) {
    let lastKnownHeight = host.offsetHeight;
    let wasEmpty = false;
    new MutationObserver(() => {
      const h = host.offsetHeight;
      if (h > 0) lastKnownHeight = h;
    }).observe(host, { attributes: true, attributeFilter: ['style'] });
    const observer = new MutationObserver(() => {
      const isEmpty = shadow.childNodes.length === 0 ||
        [...shadow.childNodes].every(n => n.nodeType === 8);
      const h = host.offsetHeight;
      if (h > 0) lastKnownHeight = h;
      if (isEmpty && !wasEmpty) {
        wasEmpty = true;
        const fromHeight = lastKnownHeight;
        if (cancelCurrent) cancelCurrent();
        host.style.setProperty('position', 'absolute', 'important');
        host.style.setProperty('width', host.offsetWidth + 'px', 'important');
        host.style.setProperty('height', fromHeight + 'px', 'important');
        host.style.setProperty('padding', '0', 'important');
        host.style.setProperty('overflow', 'hidden', 'important');
        host.style.setProperty('opacity', '1', 'important');
        host.style.setProperty('background', 'transparent', 'important');
        cancelCurrent = animateEase({
          from: fromHeight, to: 0,
          onUpdate: v => {
            host.style.setProperty('height', v + 'px', 'important');
            host.style.setProperty('opacity', String(Math.max(v / fromHeight, 0)), 'important');
            if (v <= 0.1) {
              host.style.setProperty('height', '0px', 'important');
              requestAnimationFrame(() => {
                host.style.removeProperty('height');
                host.style.removeProperty('overflow');
                host.style.removeProperty('opacity');
              });
            }
          }
        });
        restoreThemePriceBlock();
      } else if (!isEmpty && wasEmpty) {
        wasEmpty = false;
        shadow.querySelector('style[data-rc-custom]')?.remove();
        shadow._rcPriceWatcher = false;
        host.style.removeProperty('position');
        host.style.removeProperty('width');
        host.style.removeProperty('padding');
        host.style.removeProperty('background');
        watchPriceSignals(shadow);
        if (!customize(shadow, host)) {
          const reRenderObserver = new MutationObserver(() => {
            if (customize(shadow, host)) reRenderObserver.disconnect();
          });
          reRenderObserver.observe(shadow, { childList: true, subtree: true });
        }
        requestAnimationFrame(() => {
          const naturalHeight = host.scrollHeight;
          lastKnownHeight = naturalHeight;
          if (cancelCurrent) cancelCurrent();
          host.style.setProperty('height', '0px', 'important');
          host.style.setProperty('overflow', 'hidden', 'important');
          host.style.setProperty('opacity', '0', 'important');
          cancelCurrent = animateEase({
            from: 0, to: naturalHeight,
            onUpdate: v => {
              host.style.setProperty('height', v + 'px', 'important');
              host.style.setProperty('opacity', String(Math.min(v / naturalHeight, 1)), 'important');
              if (v >= naturalHeight - 0.5) {
                host.style.removeProperty('height');
                host.style.removeProperty('overflow');
                host.style.removeProperty('opacity');
              }
            }
          });
        });
      }
    });
    observer.observe(shadow, { childList: true });
 watchPriceSignals(shadow);
    if (!customize(shadow, host)) {
      const initObserver = new MutationObserver(() => {
        if (customize(shadow, host)) initObserver.disconnect();
      });
      initObserver.observe(shadow, { childList: true, subtree: true });
    }
    watchPriceOverwrite(shadow);
    const mainIdInput = document.querySelector('product-form.m-product-form--main input[name="id"]');
    mainIdInput?.addEventListener('change', (e) => syncSubscriptionPrice(shadow, e.target.value));
  }
  // Shipment totals are display-only. Discounts always come from Shopify allocations.
  const productRequests = new Map();
  const displayStates = new WeakMap();
  const quantityStates = new WeakMap();
  const watchedHosts = new WeakSet();
  let currentDisplay = null;
  let syncRevision = 0;
  function widgetHost(shadow) { return shadow.host; }
  function mainRoot(shadow) {
    return widgetHost(shadow)?.closest('product-info')
      || document.querySelector('product-info[data-section-type="product-page"]')
      || document;
  }
  function deepRoots(root) {
    const roots = [root];
    for (const el of root.querySelectorAll('*')) {
      if (el.shadowRoot) roots.push(...deepRoots(el.shadowRoot));
    }
    return roots;
  }
  function selectedPlanId(shadow) {
    for (const root of deepRoots(shadow)) {
      const checked = root.querySelector('input[name="rc_plan"]:checked');
      if (checked) return String(checked.value);
      const select = root.querySelector('select[name="rc_plan"]');
      if (select?.value) return String(select.value);
    }
    const input = mainRoot(shadow).querySelector('input[name="selling_plan"]');
    return input?.value || String(widgetHost(shadow)?.sellingPlanId || '');
  }
  function planOptions(plan, group) {
    return (plan.options || []).map((option, index) => {
      const fallback = group.options?.[index];
      return {
        key: option?.key || option?.name || fallback?.name || fallback || '',
        value: option?.value ?? option
      };
    });
  }
  function shipmentModel(product, variantId, planId) {
    const variant = product.variants?.find(v => String(v.id) === String(variantId));
    if (!variant) return null;
    const group = product.selling_plan_groups?.find(g =>
      g.selling_plans?.some(p => String(p.id) === String(planId)));
    const plan = group?.selling_plans?.find(p => String(p.id) === String(planId));
    const allocation = variant.selling_plan_allocations?.find(a =>
      String(a.selling_plan_id) === String(planId));
    if (!plan || !allocation) return null;
    const options = planOptions(plan, group);
    const quantityOption = options.find(o => o.key === 'Product Quantity');
    const rawQuantity = Number.parseInt(quantityOption?.value, 10);
    const managedQuantity = Number.isInteger(rawQuantity) && rawQuantity > 0;
    const quantity = managedQuantity ? rawQuantity : 1;
    const frequencyOption = options.find(o => o.key === 'Order Frequency and Unit');
    const frequency = String(frequencyOption?.value || '').match(/^(\d+)-(day|week|month|year)s?$/i);
    const unitSale = Number(allocation.price);
    const unitRegular = Number(allocation.compare_at_price ?? variant.price);
    if (!Number.isFinite(unitSale) || !Number.isFinite(unitRegular)) return null;
    return {
      variant, plan, allocation, quantity, managedQuantity,
      interval: frequency ? Number(frequency[1]) : null,
      intervalUnit: frequency ? frequency[2].toLowerCase() : null,
      unitSale, unitRegular,
      sale: unitSale * quantity,
      regular: unitRegular * quantity,
      discount: unitRegular > unitSale ? Math.round((1 - unitSale / unitRegular) * 100) : 0
    };
  }
  function setText(el, text) {
    if (el && el.textContent !== text) el.textContent = text;
  }
  function refreshPriceRefs(shadow) {
    const root = mainRoot(shadow);
    _priceWrapper = root.querySelector('.m-price, .price');
    _priceSaleEl = _priceWrapper?.querySelector('.m-price-item--sale, .price-item--sale');
    _priceRegEl = _priceWrapper?.querySelector('.m-price-item--regular, .price-item--regular');
  }
  function syncWidgetPrice(shadow, model) {
    const sub = shadow.querySelector('.rc-purchase-option__subscription');
    const container = sub?.querySelector('.rc-purchase-option__prices');
    if (!container) return;
    container.setAttribute('data-pl-shipment-price', '');
    let total = container.querySelector('[data-pl-total-price]');
    if (!total) {
      total = document.createElement('span');
      total.setAttribute('data-pl-total-price', '');
      total.setAttribute('role', 'text');
      container.appendChild(total);
    }
    const signature = `${model.regular}:${model.sale}:${model.quantity}`;
    if (total.dataset.signature !== signature) {
      total.dataset.signature = signature;
      total.replaceChildren();
      if (model.regular > model.sale) {
        const regular = document.createElement('span');
        regular.className = 'rc-price strike-through text-muted';
        regular.textContent = formatPrice(model.regular);
        total.appendChild(regular);
      }
      const sale = document.createElement('span');
      sale.className = 'rc-price';
      sale.textContent = formatPrice(model.sale);
      total.appendChild(sale);
      total.setAttribute('aria-label', model.regular > model.sale
        ? `Original price ${formatPrice(model.regular)}. Discounted price ${formatPrice(model.sale)} per shipment.`
        : `${formatPrice(model.sale)} per shipment.`);
    }
  }
  function syncWidgetDiscount(shadow, model) {
    const sub = shadow.querySelector('.rc-purchase-option__subscription');
    const selector = sub?.querySelector('.rc-purchase-option__selector');
    selector?.querySelectorAll('[data-rc-badge-text]').forEach(el => el.remove());
    if (selector) {
      const label = model.discount > 0 ? `Autoship & Save ${model.discount}%` : 'Autoship';
      const node = [...selector.childNodes].find(n => n.nodeType === 3 && /autoship|subscribe|\{discount\}/i.test(n.textContent));
      if (node && node.textContent.trim() !== label) node.textContent = ' ' + label + ' ';
    }
    const badge = shadow.querySelector('#rc-subscription-badge');
    if (badge) {
      const value = model.discount > 0 ? `Save ${model.discount}%` : '';
      setText(badge, value);
      badge.style.setProperty('display', value ? 'flex' : 'none', 'important');
    }
  }
  function benefitsList(shadow) {
    const benefits = shadow.querySelector('.rc-purchase-option__sub-container:not([data-rc-clone]) rc-benefits');
    if (benefits?.shadowRoot) {
      injectBenefitsStyle(benefits);
      let ul = benefits.shadowRoot.querySelector('ul');
      if (!ul) {
        ul = document.createElement('ul');
        ul.className = 'rc-benefits__list';
        benefits.shadowRoot.appendChild(ul);
      }
      return ul;
    }
    // Temporary fallback if a quantity plan doesn't render Recharge's benefit component.
    const sub = shadow.querySelector('.rc-purchase-option__sub-container:not([data-rc-clone])');
    if (!sub) return null;
    let ul = sub.querySelector('[data-pl-benefits-fallback]');
    if (!ul) {
      ul = document.createElement('ul');
      ul.setAttribute('data-pl-benefits-fallback', '');
      sub.appendChild(ul);
    }
    return ul;
  }
  function syncBenefits(shadow, model) {
    const native = shadow.querySelector('.rc-purchase-option__sub-container:not([data-rc-clone]) rc-benefits');
    if (native?.shadowRoot) shadow.querySelector('[data-pl-benefits-fallback]')?.remove();
    const ul = benefitsList(shadow);
    if (!ul) return;
    const rows = [...ul.querySelectorAll('li')];
    let savings = rows.find(li => li.hasAttribute('data-pl-save-benefit'))
      || rows.find(li => /save.*autoship|save.*\{discount\}|\{discount\}.*order/i.test(li.textContent));
    if (model.discount > 0) {
      if (!savings) {
        savings = document.createElement('li');
        ul.prepend(savings);
      }
      savings.setAttribute('data-pl-save-benefit', '');
      setText(savings, `Save ${model.discount}% on all autoship orders.`);
      savings.hidden = false;
    } else if (savings) {
      savings.hidden = true;
    }
    if (!rows.some(li => /modify.*cancel|cancel.*anytime/i.test(li.textContent))) {
      const cancel = document.createElement('li');
      cancel.setAttribute('data-pl-cancel-benefit', '');
      cancel.textContent = 'Modify or cancel anytime.';
      ul.appendChild(cancel);
    }
    let equivalent = ul.querySelector('[data-pl-monthly-equivalent]');
    if (model.managedQuantity && model.quantity > 1 && model.intervalUnit === 'month' && model.interval > 1) {
      if (!equivalent) {
        equivalent = document.createElement('li');
        equivalent.setAttribute('data-pl-monthly-equivalent', '');
        ul.appendChild(equivalent);
      }
      setText(equivalent, `${formatPrice(model.sale / model.interval)} per month equivalent — ${formatPrice(model.sale)} billed every ${model.interval} months.`);
    } else {
      equivalent?.remove();
    }
  }
  function quantityInputs(shadow) {
    const root = mainRoot(shadow);
    const sectionId = root.dataset?.sectionId;
    return [...document.querySelectorAll('input[name="quantity"]')].filter(input =>
      root !== document && root.contains(input)
      || (sectionId && input.form?.id === 'sticky-atc-form-' + sectionId));
  }
  function setPlanQuantity(shadow, model) {
    const managed = !!model?.managedQuantity;
    for (const input of quantityInputs(shadow)) {
      const control = input.closest('m-quantity-input, quantity-input, .m-quantity');
      if (managed) {
        if (!quantityStates.has(input)) quantityStates.set(input, input.value);
        if (input.value !== String(model.quantity)) {
          input.value = String(model.quantity);
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
        input.setAttribute('value', String(model.quantity));
        control?.setAttribute('data-pl-rc-quantity-hidden', '');
      } else if (quantityStates.has(input)) {
        input.value = quantityStates.get(input);
        input.setAttribute('value', input.value);
        quantityStates.delete(input);
        control?.removeAttribute('data-pl-rc-quantity-hidden');
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
    currentDisplay = { shadow, model: managed ? model : null };
  }
  function shipmentStyles(shadow) {
    if (!document.querySelector('[data-pl-rc-quantity-style]')) {
      const style = document.createElement('style');
      style.setAttribute('data-pl-rc-quantity-style', '');
      style.textContent = '[data-pl-rc-quantity-hidden]{display:none!important}';
      document.head.appendChild(style);
    }
    if (shadow.querySelector('[data-pl-rc-shipment-style]')) return;
    const style = document.createElement('style');
    style.setAttribute('data-pl-rc-shipment-style', '');
    style.textContent = `
    [data-pl-total-price] > .rc-price:not(.strike-through) {color: #0F866A !important;}
      [data-pl-shipment-price] > :not([data-pl-total-price]) { display:none!important; }
      [data-pl-total-price] { display:inline-flex; align-items:baseline; gap:6px; }
      [data-pl-benefits-fallback] { list-style:none; padding:0; margin:10px 0; }
      [data-pl-benefits-fallback] li { font-family:var(--font-lay-grotesk); font-size:13px; line-height:24px; color:#2f27ce; }
      [data-pl-benefits-fallback] li[hidden] { display:none!important; }
    `;
    shadow.appendChild(style);
  }
  function drainDisplayObservers(shadow) {
    displayStates.get(shadow)?.observers.forEach(observer => observer.takeRecords());
  }
  function setupDisplayObservers(shadow) {
    let state = displayStates.get(shadow);
    if (!state) {
      state = { roots: new WeakSet(), observers: [], queued: false };
      displayStates.set(shadow, state);
    }
    for (const root of deepRoots(shadow)) {
      if (state.roots.has(root)) continue;
      state.roots.add(root);
      const observer = new MutationObserver(() => {
        if (state.queued) return;
        state.queued = true;
        requestAnimationFrame(() => {
          state.queued = false;
          if (widgetHost(shadow)?.isConnected) {
            setupDisplayObservers(shadow);
            syncSubscriptionPrice(shadow);
          }
        });
      });
      observer.observe(root, { childList: true, subtree: true, characterData: true,
        attributes: true, attributeFilter: ['checked', 'rc-selected', 'data-checked'] });
      state.observers.push(observer);
    }
  }
  document.addEventListener('submit', event => {
    const state = currentDisplay;
    if (!state?.model || !widgetHost(state.shadow)?.isConnected) return;
    if (quantityInputs(state.shadow).some(input => input.form === event.target)) {
      quantityInputs(state.shadow).forEach(input => { input.value = String(state.model.quantity); });
    }
  }, true);
  // ─── Boot ──────────────────────────────────────────────────────────────────
  function watchForHost() {
    function connect() {
      const host = document.querySelector('recharge-subscription-widget');
      if (!host?.shadowRoot || watchedHosts.has(host)) return;
      watchedHosts.add(host);
      watchShadow(host.shadowRoot, host);
      setupDisplayObservers(host.shadowRoot);
      [0, 80, 250, 600, 1200].forEach(delay => setTimeout(() => {
        if (!host.isConnected) return;
        setupDisplayObservers(host.shadowRoot);
        customize(host.shadowRoot, host);
      }, delay));
    }
    connect();
    new MutationObserver(connect).observe(document.body, { childList: true, subtree: true });
  }
  fetchProductData();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchForHost);
  } else {
    watchForHost();
  }
})();
